import { EfsaSampnt, useDeleteSampntMutation } from 'prove-common'
import { SamplingSiteForm } from '../../components/reference-data/ReferenceEntityForms'
import { ReferenceTable } from '../reference-table/ReferenceTable'

export const SamplingSitesTable = ({
  samplingSites
}: {
  samplingSites: EfsaSampnt[]
}) => {
  const remove = useDeleteSampntMutation()
  return (
    <ReferenceTable
      rows={samplingSites}
      title='Uttakssteder'
      emptyTitle='Ingen uttakssteder'
      columns={[
        { key: 'nameNo', label: 'Navn (NO)', value: (row) => row.nameNo },
        { key: 'nameEn', label: 'Navn (EN)', value: (row) => row.nameEn },
        { key: 'code', label: 'Kode', value: (row) => row.code },
        { key: 'id', label: 'ID', value: (row) => row.id, copy: true }
      ]}
      name={(row) => row.nameNo}
      editForm={(row, close) => <SamplingSiteForm site={row} onClose={close} />}
      onDelete={(id) => remove.mutateAsync(id)}
    />
  )
}
